var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inicio_configuraci\\xF3n",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3E1293;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    className: "st0",
    d: "M16.9,13.5c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4 C15.4,10.1,16.9,11.6,16.9,13.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    className: "st0",
    d: "M21.8,16.9c-0.3,0.7-0.2,1.5,0.4,2l0.1,0.1c0.9,0.9,0.9,2.3,0,3.2s-2.3,0.9-3.2,0l0,0L19,22.1 c-0.7-0.7-1.9-0.7-2.6,0c-0.3,0.3-0.5,0.8-0.5,1.3v0.2c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2v-0.1c-0.1-1.1-1-1.9-2.1-1.8 c-0.5,0-0.9,0.2-1.2,0.5L8,22.3c-0.9,0.9-2.3,0.9-3.2,0c-0.9-0.9-0.9-2.3,0-3.2L4.9,19c0.7-0.7,0.7-1.9,0-2.6 C4.5,16,4,15.8,3.6,15.8H3.4c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h0.1c1.1-0.1,1.9-1,1.8-2c0-0.5-0.2-0.9-0.5-1.2L4.7,8 c-0.9-0.9-0.9-2.3,0-3.2s2.3-0.9,3.2,0L8,4.9c0.5,0.5,1.4,0.7,2,0.4h0.1c0.7-0.3,1.1-1,1.1-1.7V3.4c0-1.2,1-2.2,2.2-2.2 s2.2,1,2.2,2.2v0.1c0,1,0.9,1.9,1.9,1.9c0.5,0,0.9-0.2,1.3-0.5L19,4.7c0.9-0.9,2.3-0.9,3.2,0s0.9,2.3,0,3.2l0,0L22.1,8 c-0.5,0.5-0.7,1.4-0.4,2v0.1c0.3,0.7,1,1.1,1.7,1.1h0.2c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2h-0.1C22.8,15.8,22.1,16.2,21.8,16.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    className: "st1",
    d: "M0,0h27v27H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.bf3f7077d7d83b9cee066fff946d70f5.svg";
export { ForwardRef as ReactComponent };